import { Col, H2, Row, Section, Wrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

import { focusVisible } from '../branch';

export const Heading = styled(H2)`
  @media (min-width: ${({ theme }) => theme.media.sm}) {
    margin-bottom: 2.5rem;
  }

  ${focusVisible}
`;

export const AlertSection = styled(Section)`
  padding: 0;
`;

export const AlertWrapper = styled(Wrapper)`
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    padding: 0 0.5rem;
  }
`;

export const OptionsSection = styled(Section)`
  display: flex;
  justify-content: center;

  padding: 4rem 0;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    padding: 5.5rem 0;
  }

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    padding: 7.5rem 0;
  }
`;

export const OptionsContainer = styled.div`
  flex-direction: column;
`;

export const OptionsInnerContainer = styled.div`
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    width: 75%;
  }
`;

export const OptionsRow = styled(Row)`
  justify-content: center;
  padding: 0.5rem 0 1.5rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    padding: 1.25rem 0 0;
  }
`;

export const OptionColumn = styled(Col)`
  padding: 0.75rem 1.5rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    padding: 1.85rem 1.25rem;
  }
`;

export const AnnouncementWrapper = styled.div`
  padding-bottom: 1.5rem;

  @media (max-width: ${({ theme }) => theme.media.sm}) {
    margin: 0 -1rem;
  }

  @media (max-width: ${({ theme }) => theme.media.lg}) {
    margin: 0 -0.5rem;
  }
`;
